import { Conversation_externalLead_scheduledOutreach } from 'types/apollo/Conversation';
import { Leads_externalLeads_statusCounts } from 'types/apollo/Leads';
import { NOT_SET } from './lead-status-chip';

/**
 * Extracts expiration timestamp from a signed URL
 */
export const extractExpiration = (src: string | null): number | null => {
  if (src) {
    const expiresRegex = /Expires=(\d+)/;
    const match = src.match(expiresRegex);

    if (match) {
      return parseInt(match[1]) * 1000;
    }
  }
  return null;
};

/**
 * Returns a human-readable label for a scheduled outreach item
 */
export const labelForItem = (it: Conversation_externalLead_scheduledOutreach): string => {
  switch (it.kind) {
    case 'REM':
      return 'Reminder text scheduled';
    case 'SCHEDULE':
      return 'Call scheduled';
    case 'FLOW': {
      const intent = it.intent ?? (it.messagePreview ? 'sms' : undefined);
      if (intent === 'call') return 'Call scheduled';
      if (intent === 'sms') return 'Text scheduled';
      return 'Flow step scheduled';
    }
    case 'REPLY':
      return 'Reply scheduled';
    default:
      return 'Scheduled';
  }
};

/**
 * Extracts initials from first and last name
 */
export const getInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string => {
  return (firstName?.charAt(0) ?? '') + (lastName?.charAt(0) ?? '');
};

/**
 * Calculates total count based on selected status filters
 */
export const getTotalCountByFilters = (
  filters: string[],
  statusCounts: Leads_externalLeads_statusCounts[],
): number =>
  statusCounts.reduce((acc, { count, status }) => {
    if (filters.includes(status ?? NOT_SET)) {
      return acc + Number(count);
    }
    return acc;
  }, 0);
